import ScrollPage, { SectionItem } from "../../Components/ScrollPage/ScrollPage";
import Section from "../../Components/Section/Section";
import PipeDriveEmbed from "./PipeDriveEmbed";

interface ScrollTo {
    index: number;
}

export const Sections: SectionItem[] = [
    { label: "Pipedrive", id: "pipedrive" }
];


const PipeDrivePage: React.FC<ScrollTo> = ({ index }) => (
    // you can also get rid of everything and just imitate the espec page you have made in espec
    <ScrollPage index={index} sections={Sections}>
        <Section section={Sections[0].id}>
            <PipeDriveEmbed index={0}/>


        </Section>
    </ScrollPage>
);

export default PipeDrivePage;